import { render, staticRenderFns } from "./RelatorioSalesOrderPreview.vue?vue&type=template&id=478f684f&scoped=true"
import script from "./RelatorioSalesOrderPreview.vue?vue&type=script&lang=js"
export * from "./RelatorioSalesOrderPreview.vue?vue&type=script&lang=js"
import style0 from "./RelatorioSalesOrderPreview.vue?vue&type=style&index=0&id=478f684f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478f684f",
  null
  
)

export default component.exports